import React from 'react';
import { FakeLinkComponent } from '@rsos/components/capstone/base';
import {
  SUBMITTED,
  PROCESSING,
  AWAITING_CUSTOMER_REVIEW,
  VERIFIED,
  ACTIVE,
} from '../../../constants/issueStatuses';

export const determineAction = (issue, handleReview, handleView, psap) => {
  const inactive = () => (
    <FakeLinkComponent type="primary" disabled>
      View
    </FakeLinkComponent>
  );
  const review = () => (
    <FakeLinkComponent type="primary" onClick={() => handleReview(issue)}>
      Review
    </FakeLinkComponent>
  );
  const view = () => (
    <FakeLinkComponent
      type="primary"
      onClick={handleView}
      disabled={psap.isGettingPSAPInfo}
    >
      View
    </FakeLinkComponent>
  );
  switch (issue.status) {
    case SUBMITTED:
    case PROCESSING:
      return inactive();
    case AWAITING_CUSTOMER_REVIEW:
      return review();
    case VERIFIED:
    case ACTIVE:
      return view();
    default:
      return inactive();
  }
};
